class e extends Error {
}
export {
  e as ServerError
};
